import * as React from "react";
import { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Linking, View, Image, Text, StyleSheet, useWindowDimensions } from "react-native";
import WebButton from "../components/WebButton";
import WebButtonExplore from "../components/WebButtonExplore";
import WebButtonTripleDots from "../components/WebButtonTripleDots";
import GetAppOnAndroid from "./MiscImpl/GetAppOnAndroid";
import GetAppOnIOS from "./MiscImpl/GetAppOnIOS";
import { TouchableOpacity } from "react-native-gesture-handler";
import { GlobalSettingsContext } from "../context/GlobalSettingsProvider.js";

export default function WebWelcomeScreen({
    route,
    setCategory,
    authToken,
    userDetails,
    navigation: { goBack, navigate, setParams },
}) {
    const window = useWindowDimensions();

    const { globalSettings } = useContext(GlobalSettingsContext);
    const [colourTheme1, setColourTheme1] = React.useState("#ad0000");

    const colorShade = (col, amt) => {
        col = col.replace(/^#/, '')
        if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2]

        let [r, g, b] = col.match(/.{2}/g);
        ([r, g, b] = [parseInt(r, 16) + amt, parseInt(g, 16) + amt, parseInt(b, 16) + amt])

        r = Math.max(Math.min(255, r), 0).toString(16)
        g = Math.max(Math.min(255, g), 0).toString(16)
        b = Math.max(Math.min(255, b), 0).toString(16)

        const rr = (r.length < 2 ? '0' : '') + r
        const gg = (g.length < 2 ? '0' : '') + g
        const bb = (b.length < 2 ? '0' : '') + b

        return `#${rr}${gg}${bb}`
    }

    React.useEffect(() => {
        setColourTheme1(globalSettings.find(
            (a) => a && a.description.toLowerCase() === "colour theme 2"
        )?.value)
    });

    return (
        <React.Fragment>
            <View style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                <View style={{ flex: 1, display: "flex", }}>
                    <View style={{
                        minWidth: "50%",
                        width: "100%",
                        flex: 1,
                        display: "flex",
                        alignItems: "flex-end",
                        flexDirection: "row-reverse",
                        paddingRight: 42,
                        paddingBottom: 16
                    }}>
                        {/* Optionally add triple dots to offer dark mode or languages in the future? Nothing comes up yet, coming soon! */}
                        {/* <WebButtonTripleDots /> */}
                    </View>
                </View>
                <View style={{ display: "flex", flex: 17, flexDirection: "column" }}>
                    <View style={{ display: "flex", flex: 1, flexDirection: "row" }}>
                        {window.width > 500 &&
                            <View style={{ display: "flex", flex: 1, flexDirection: "row-reverse" }}>
                                <View style={{
                                    display: "flex",
                                    maxWidth: 1129,
                                    maxWidth: "60%",
                                    minWidth: "50%",
                                    alignItems: "flex-end",
                                    paddingTop: 41,
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    display: "flex",
                                    flex: 1,
                                }}>
                                    <Image
                                        source={require("../assets/images/frontpage.png")}
                                        resizeMode={"contain"}
                                        style={{
                                            resizeMode: 'contain',
                                            height: '100%',
                                            width: '100%',
                                        }}
                                    />
                                </View>
                            </View>}
                        <View style={{
                            display: "flex",
                            flex: 1,
                            maxWidth: 1129,
                            maxWidth: window.width <= 500 ? "none" : "60%",
                            minWidth: window.width <= 500 ? "none" : "50%",
                            alignItems: "center",
                            paddingTop: 41,
                            flexDirection: "column",
                            justifyContent: "center",
                            display: "flex",
                        }}>
                            <Image
                                source={require("../assets/images/robot-dev.png")}
                                style={{
                                    width: 100,
                                    height: 80,
                                    resizeMode: "contain",
                                    marginTop: 3,
                                    marginLeft: -10,
                                }}
                            />
                            <Text style={{
                                fontSize: 64,
                                marginBottom: 24,
                                fontWeight: "bold",
                            }}>
                                Delta News
                            </Text>
                            <Text style={{ color: "grey", maxWidth: 400, textAlign: "center", }}>
                                A brand new, news platform that combines both value and principle, including entertainment and sports. Be a part of the community today!
                            </Text>
                            <TouchableOpacity style={{ paddingTop: 24, }} onPress={() => navigate("Register")}>
                                <WebButton
                                    text="Create Account"
                                    styleFade={
                                        {
                                            width: "auto",
                                            height: "48px",
                                            maxWidth: "426px",
                                            minWidth: "320px",
                                            lineHeight: "48px",
                                            borderRadius: "100px",
                                            backgroundColor: colorShade(colourTheme1 + "", -40),
                                            elevation: 1,
                                            zIndex: 1,
                                        }
                                    } />
                            </TouchableOpacity>
                            <TouchableOpacity style={{ paddingTop: 24, }} onPress={() => navigate("Login")}>
                                <WebButton
                                    text="Log In"
                                    textColor={"black"}
                                    style={
                                        {
                                            width: "auto",
                                            height: "48px",
                                            maxWidth: "426px",
                                            minWidth: "320px",
                                            lineHeight: "48px",
                                            borderRadius: "100px",
                                            borderWidth: "1.75px",
                                            backgroundColor: "white",
                                            borderColor: "grey",
                                            elevation: 1,
                                            zIndex: 1,
                                        }
                                    }
                                    styleFade={
                                        {
                                            width: "auto",
                                            height: "48px",
                                            maxWidth: "426px",
                                            minWidth: "320px",
                                            lineHeight: "48px",
                                            borderRadius: "100px",
                                            backgroundColor: "#e8fdff",
                                            borderColor: "#013d78",
                                            borderWidth: "1.75px",
                                            elevation: 2,
                                            zIndex: 2,
                                            marginLeft: -2,
                                            marginTop: "-1.5px",
                                            width: "101.5%",
                                        }
                                    } />
                            </TouchableOpacity>
                            <TouchableOpacity style={{ paddingTop: 24, }} onPress={() => navigate("ArticleList")}>
                                <WebButtonExplore />
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
                <View style={{
                    display: "flex", flex: 3, flexDirection: "column",
                    flexGrow: 1, maxHeight: 120, flexBasis: "10%"
                }}>
                    <Text style={{
                        color: "black",
                        alignItems: "center",
                        alignSelf: "center",
                        justifyContent: "center",
                        textAlignVertical: 'center',
                        flexDirection: 'row',
                        fontSize: 14,
                        fontWeight: "600",
                        textAlign: 'center',
                        textAlignVertical: 'center',
                        elevation: 5,
                        zIndex: 5,
                    }}>
                        Get app here
                    </Text>
                    <View style={{
                        alignItems: "center",
                        alignSelf: "center",
                        justifyContent: "center",
                        textAlignVertical: 'center',
                        flexDirection: 'row',
                        fontSize: 14,
                        elevation: 5,
                        zIndex: 5,
                        marginTop: window.width <= 500 ? 0 : 16,
                    }}>
                        <TouchableOpacity onPress={() => Linking.openURL('http://www.apple.com')}>
                            <GetAppOnIOS />
                        </TouchableOpacity>
                        <TouchableOpacity onPress={() => Linking.openURL('http://www.android.com')}>
                            <GetAppOnAndroid />
                        </TouchableOpacity>
                    </View>
                </View>
                <View style={{ display: "flex", flex: 1, flexDirection: "column", }}>
                    <View style={{
                        flex: 1,
                        color: "gray",
                        alignItems: "flex-end",
                        alignSelf: "center",
                        justifyContent: "flex-end",
                        flexDirection: 'row',
                        fontSize: 14,
                        fontWeight: "600",
                        elevation: 5,
                        zIndex: 5,
                        marginBottom: 24,
                        marginLeft: window.width <= 500 ? 12 : 0,
                    }}>

                        <Text style={{ color: "grey", fontWeight: "600" }} onPress={() => navigate("Information", { data: "about us" })}>
                            About Us
                        </Text>

                        <Text style={{ color: "grey", fontWeight: "600", marginLeft: 24, }} onPress={() => navigate("Information", { data: "terms and conditions" })}>
                            Terms & Conditions
                        </Text>

                        <Text style={{ color: "grey", fontWeight: "600", paddingLeft: 24, }} onPress={() => navigate("Information", { data: "privacy policy" })}>
                            Privacy Policy
                        </Text>

                        <Text style={{ color: "grey", fontWeight: "600", paddingLeft: 24, }} onPress={() => navigate("Information", { data: "cookie policy" })}>
                            Cookie Policy
                        </Text>

                        <Text style={{ color: "grey", fontWeight: "600", paddingLeft: 24, }}>
                            2022 Delta News, ltd.
                        </Text>

                    </View>
                </View>
            </View>
        </React.Fragment >
    );
}

WebWelcomeScreen.navigationOptions = {
    header: null,
};

WebWelcomeScreen.propTypes = {
    text: PropTypes.string,
};